<template>
  <a-breadcrumb>
    <a-breadcrumb-item :key="index" v-for="(item, index) in breadcrumb">
      <span v-if="typeof item === 'string'">{{ item }}</span>
      <span v-else-if="!item.path">{{ item.name }}</span>
      <span v-else @click="linkPath(item, index)" class="link">{{ item.name }}</span>
    </a-breadcrumb-item>
  </a-breadcrumb>
</template>
<script>
export default {
  name: 'MyBreadcrumb',
  data() {
    return {
      query: {},
    }
  },
  props: {
    list: {
      type: Array,
      default: null,
    },
  },
  watch: {
    $route: {
      handler() {
        const breadcrumb = this.getBreadcrumb()
        this.$store.commit('account/set_breadcrumb', breadcrumb)
      },
      immediate: true,
    },
  },
  computed: {
    breadcrumb() {
      return this.list || this.$store.state.account.breadcrumb
    },
  },
  methods: {
    linkPath(item, index) {
      if (index <= 1) return
      if (index == this.breadcrumb.length - 1) return
      if (this.$listeners.link) {
        this.$emit('link', item, this.breadcrumb)
      } else {
        const query = this.$store.state.account.query[item.path]
        const path = query && query.fullPath ? query.fullPath : item.path
        typeof item.path === 'number' ? this.$router.go(item.path) : this.$router.replace(path)
      }
    },
    replaceTitleById(name, queryId) {
      if (/(\u6dfb\u52a0\/\u7f16\u8f91)/.test(name)) {
        if (queryId) {
          name = name.replace('添加/编辑', '编辑')
        } else {
          name = name.replace('添加/编辑', '添加')
        }
      }
      return name
    },
    getBreadcrumb() {
      const matched = this.$route.matched
      const result = []
      for (let i = 0; i < matched.length; i++) {
        const v = matched[i]
        let name = v.meta.title
        const nextItem = matched[i + 1]
        if (name && nextItem && nextItem.meta.title == name) {
          if (!nextItem.meta) {
            nextItem.meta = {}
          }
          nextItem.meta.hiddenBreadcrumd = true
        }
        if (!v.meta.hiddenBreadcrumd) {
          const queryId = this.$route.query.id
          name = this.replaceTitleById(name, queryId)
          if (this.$route.meta.title === v.meta.title) {
            this.$store.commit('account/set_query', {
              key: v.path,
              value: {
                fullPath: this.$route.fullPath,
                query: this.$route.query,
                path: this.$route.path,
              },
            })
          }
          result.push({ ...v, name: name })
        }
      }
      return result
    },
  },
}
</script>
<style scoped>
.link {
  cursor: pointer;
}
</style>
